import React, {ReactNode} from "react";
import styles from "./app-tag.module.css";
import {cn} from "@/lib/utils";

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children: ReactNode;
}

export const AppTag = ({children, className, ...props}: IProps) => {
    return (
        <div
            className={cn('px-[10px] flex items-center justify-center py-[5px] font-bold text-orange-main uppercase', className, styles.Tag)} {...props}>{children}</div>
    )
}
